import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import UserList from "../components/UserList";
import UserForm from "../components/UserForm";
import { users as initialUsers } from "../utils/dummyData";
import {
  createUser,
  deleteUser,
  getAllRoles,
  getAllUsers,
  updateUser,
} from "../services/api";
import { toast, ToastContainer } from "react-toastify";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [roles, setRoles] = useState([]);
  const [onEdit, setOnEdit] = useState(false);

  const _getAllUsers = async () => {
    const getAllUsersApi = await getAllUsers();
    if (getAllUsersApi && getAllUsersApi.success) {
      setUsers(getAllUsersApi.data);
    }
  };

  const _getAllRoles = async () => {
    const getAllRolesApi = await getAllRoles();
    if (getAllRolesApi && getAllRolesApi.success) {
      setRoles(getAllRolesApi.data);
    }
  };
  useEffect(() => {
    _getAllUsers();
    _getAllRoles();
  }, []);

  const handleAddUser = () => {
    setCurrentUser(null);
    setOnEdit(false);
    setOpenForm(true);
  };

  const handleEditUser = (user) => {
    setCurrentUser(user);
    setOnEdit(true);
    setOpenForm(true);
  };

  const handleDeleteUser = (userId) => {
    setDeleteConfirm(userId);
  };

  const confirmDelete = async () => {
    await deleteUser(deleteConfirm);
    _getAllUsers();
    setDeleteConfirm(null);
  };

  const handleSubmit = async (userData) => {
    let userApi = null;
    if (userData.ID) {
      userApi = await updateUser(userData.ID, userData);
    } else {
      userApi = await createUser(userData);
    }
    if (userApi && userApi.success) {
      toast.success(userApi.message);
      _getAllUsers();
      setOpenForm(false);
    } else {
      toast.error(userApi.message);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <ToastContainer />
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Typography variant="h4" color="#d32f2f">
          User Management
        </Typography>
        <Button variant="contained" color="error" onClick={handleAddUser}>
          Add New User
        </Button>
      </Box>

      <UserList
        users={users}
        onEdit={handleEditUser}
        onDelete={handleDeleteUser}
      />

      {/* User Form Dialog */}
      <Dialog open={openForm} onClose={() => setOpenForm(false)}>
        <DialogTitle>{currentUser ? "Edit User" : "Add New User"}</DialogTitle>
        <DialogContent>
          <UserForm
            user={currentUser}
            roles={roles}
            onSubmit={handleSubmit}
            onCancel={() => setOpenForm(false)}
            onEdit={onEdit}
          />
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={Boolean(deleteConfirm)}
        onClose={() => setDeleteConfirm(null)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this user?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirm(null)}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Users;
